module.exports = __webpack_public_path__ + "img/company-logo.786f5278.svg";